document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".zsc-button").forEach(button => {

    button.addEventListener("click", function(e){

      e.preventDefault();

      const size = this.dataset.size.trim().toUpperCase();

      // Buscar la variante correspondiente
      document.querySelectorAll('input[type="radio"]').forEach(radio=>{

        if(radio.value.toUpperCase().startsWith(size)){

          radio.click();

          radio.checked = true;

          radio.dispatchEvent(new Event("change",{bubbles:true}));

        }

      });

      // Scroll al selector de variantes
      const selector=document.querySelector(".variant-picker__form");

      if(selector){

        selector.scrollIntoView({

          behavior:"smooth",

          block:"center"

        });

      }

    });

  });

});